export enum LockboxPermissionType {
  Owner = 'owner',
  Assignee = 'assignee',
}

export enum ShackleSetting {
  None = 'none',
  Everyone = 'everyone',
  Individual = 'individual',
}
